import { countryName } from '@/features/patients/countries';
import type { PatientIdentity } from '@/features/patients/types';

/**
 * "880412-04-5531" for MyKad; "C4417720 · Vietnam passport" for a passport:
 * the country is the passport's issuing country, labelled as such (UAT RL-705).
 */
export function PatientIdentityText({
  identity,
}: {
  identity: PatientIdentity | null;
}) {
  if (!identity) return <span className="mono">—</span>;
  return (
    <span className="mono">
      {identity.value}
      {identity.type === 'passport' &&
        ` · ${countryName(identity.issuingCountry)} passport`}
    </span>
  );
}
